import * as types from './types';

export const getApprovalsCheckRequest = (data) => ({ type: types.GET_APPROVALS_CHECK_REQUEST, data });
export const getApprovalsCheckRequestFailure = (error) => ({ type: types.GET_APPROVALS_CHECK_REQUEST_FAILURE, error });
export const getApprovalsCheckRequestSuccess = (data) => ({ type: types.GET_APPROVALS_CHECK_REQUEST_SUCCESS, data });

export const dismissBrowserWarning = () => ({ type: types.DISMISS_BROWSER_WARNING });
